module.exports = __webpack_public_path__ + "static/media/scratch_serverless_small.740ddca4.png";